import distanceAwayMobileAvif from './images/explore/explore-768w.avif';
import distanceAwayMobileWebp from './images/explore/explore-768w.webp';
import distanceAwayMobile from './images/explore/explore-768w.png';
import distanceAwayAvif from './images/explore/explore.avif';
import distanceAwayWebp from './images/explore/explore.webp';
import distanceAway from './images/explore/explore.png';

import downloadMapsMobileAvif from './images/download/download-768w.avif';
import downloadMapsMobileWebp from './images/download/download-768w.webp';
import downloadMapsMobile from './images/download/download-768w.png';
import downloadMapsAvif from './images/download/download.avif';
import downloadMapsWebp from './images/download/download.webp';
import downloadMaps from './images/download/download.png';

import offRouteMobileAvif from './images/alerts/alerts-768w.avif';
import offRouteMobileWebp from './images/alerts/alerts-768w.webp';
import offRouteMobile from './images/alerts/alerts-768w.png';
import offRouteAvif from './images/alerts/alerts.avif';
import offRouteWebp from './images/alerts/alerts.webp';
import offRoute from './images/alerts/alerts.png';

const distanceAwayImages = {
  mobile: {
    avif: distanceAwayMobileAvif,
    webp: distanceAwayMobileWebp,
    png: distanceAwayMobile
  },
  desktop: {
    avif: distanceAwayAvif,
    webp: distanceAwayWebp,
    png: distanceAway
  }
};

const downloadMapsImages = {
  mobile: {
    avif: downloadMapsMobileAvif,
    webp: downloadMapsMobileWebp,
    png: downloadMapsMobile
  },
  desktop: {
    avif: downloadMapsAvif,
    webp: downloadMapsWebp,
    png: downloadMaps
  }
};

const offRouteAlertImages = {
  mobile: {
    avif: offRouteMobileAvif,
    webp: offRouteMobileWebp,
    png: offRouteMobile
  },
  desktop: {
    avif: offRouteAvif,
    webp: offRouteWebp,
    png: offRoute
  }
};

export default { distanceAwayImages, downloadMapsImages, offRouteAlertImages };
